// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/required/jquery.cookies-policy';

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */
export default (): void => {
	$('body').cookiesPolicy({
		lang: window.projectConfig.lang,
		css: {
			brandColor: '#1b749d',
			panel: {
				'color': '#3b3b3b',
				'background-color': '#dfe7eb',
				'font-size': '14px',
				'line-height': '22px'
			}
		}
	});
};



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/components/CookiesPolicy.js